import InnovacionDocente from  './InnovacionDocente';

export default InnovacionDocente;